module.exports = __webpack_public_path__ + "static/media/action-icon.929d447f.svg";